<template>
	<div>
		<h1>Profil</h1>

		<p>
			Client :
			<span v-b-tooltip.hover :title="client.uid">{{ client.nom }}</span>
		</p>
		<p>Prénom : {{ name }}</p>
		<p>Nom : {{ family }}</p>
		<p>Identifiant : {{ id }}</p>
		<p>Email : {{ email }}</p>
		<p v-if="!(store.state.user.rules && !store.state.user.rules.jwt)">Token: <pre v-if="jwt">{{ jwt }}</pre> <b-button variant="link" v-if="!user.jwt || !(store.state.user.rules && !store.state.user.rules.jwt_generate)" @click="generate_jwt">Générer un nouveau token</b-button></p>

		<div v-if="store.state.user.rules && !store.state.user.rules.change_env">
			<div v-if="user.env">
				<p>Environnement</p>
				<b-form-select v-model="user.env" :options="env_list" disabled=""></b-form-select>
			</div>
		</div>
		<div v-else>
			<p>Environnement</p>
			<b-form-select v-model="user.env" :options="env_list"></b-form-select>
		</div>

		<div v-if="group">
			<p>Groupe :
			<b-form-select
				stype="font-size: 50px;"
				v-model="group"
				:options="groups"
			></b-form-select></p>
		</div>

		<div v-if="client.details.profile.length > 0">
			<!-- <h4>Champs complémentaires</h4> -->
			<hr />
			<div v-for="field in client.details.profile" :key="field.name">
				<div v-if="!field.hide || isAdmin()">
					<div v-if="field.edit || isAdmin()">
						<div class="form-inline">
							<div class="form-group" style="margin-bottom: 10px">
								<span>
									{{ field.libelle }} : &nbsp;
									<b-badge v-if="field.hide" variant="warning" title="Champ masqué pour les utilisateurs normaux, visible uniquement par un admin smartmydata">
										masqué
									</b-badge>
								</span>
								<b-form-input
									:type="field.type"
									v-if="field.type != 'checkbox'"
									v-model="
										user.details[field.name]
									"></b-form-input>
								<b-checkbox
									v-else
									v-model="user.details[field.name]"></b-checkbox>
							</div>
						</div>
					</div>
					<div v-else>
						{{ field.libelle }} : {{ user.details[field.name] }}
					</div>
				</div>
			</div>
		</div>

		<br />
		<br />
		<b-button @click="update">Enregistrer</b-button>
		<br />
		<br />

		<div v-if="client.details && client.details.credits">
			Crédits restants : {{ client.credits }}
			<BarChart v-if="credits" :chartData="credits"></BarChart>
		</div>
		<BarChart v-if="bandwidth" :chartData="bandwidth"></BarChart>
		<div v-if="bandwidth">Total : {{ bandwidth_sum.toFixed(2) }} mo</div>
		<BarChart v-if="editor_bandwidth" :chartData="editor_bandwidth"></BarChart>
		<div v-if="editor_bandwidth">Total : {{ editor_bandwidth_sum.toFixed(2) }} mo</div>

		<hr />

		<div v-if="!(store.state.user.rules && !store.state.user.rules.password)">
			<p>Redéfinir mot de passe :</p>
			<form @submit="onSubmit">
				<div class="input_container">
					<ul>
						<li v-bind:class="{ is_valid: contains_eight_characters }">
							8 caractères
						</li>
						<li v-bind:class="{ is_valid: contains_number }">
							Contient un chiffre
						</li>
						<li v-bind:class="{ is_valid: contains_uppercase }">
							Contient une majuscule
						</li>
						<li v-bind:class="{ is_valid: contains_special_character }">
							Contient un caractère spécial
						</li>
					</ul>

					<div
						class="checkmark_container"
						v-bind:class="{ show_checkmark: valid_password }">
						<svg width="50%" height="50%" viewBox="0 0 140 100">
							<path
								class="checkmark"
								v-bind:class="{ checked: valid_password }"
								d="M10,50 l25,40 l95,-70" />
						</svg>
					</div>

				<div style="position: relative; display: inline-block; width: 100%;">
					<input
						:type="showPassword ? 'text' : 'password'"
						@input="checkPassword"
						v-model="password"
						autocomplete="off"
						placeholder="Password"
						style="width: 100%; padding-right: 40px;" />
					<button
						type="button"
						@click="showPassword = !showPassword"
						style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); border: none; background: transparent; cursor: pointer;">
						<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
					</button>
				</div>
					<div>
						<b-button
							v-if="valid_password"
							type="submit"
							variant="primary"
							>Valider</b-button
						>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import password from "../services/password.js";
	import BarChart from "../services/BarChart.vue";
	import LineChart from "../services/LineChart.vue";

	import moment from "moment";

	export default {
		components: {
			LineChart,
			BarChart
		},
		name: "profile",
		data() {
			return {
				user: "",
				name: "",
				family: "",
				id: "",
				email: "",
				jwt: "",
				password: null,
				password_length: 0,
				contains_eight_characters: false,
				contains_number: false,
				contains_uppercase: false,
				contains_special_character: false,
				valid_password: false,			showPassword: false,				client: { env: "", details: { profile: {} } },
				env_list: [""],
				store: {},
				user_groups: [],
				group: "",
				groups: [],
				obj_groups: {},
				credits: null,
				bandwidth: null,
				editor_bandwidth: null,
				bandwidth_sum: 0,
				editor_bandwidth_sum: 0
			};
		},
		methods: {
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
			async update() {
				if (!this.user.env) 
					this.user.env = null;
				var user = await users.updateUserSelf(this.user, this.group || null);
				this.$router.go();
			},
			async generate_jwt()
			{
				this.jwt = await users.generateJwtSelf();
				this.user.jwt = this.jwt;
			},
			onSubmit(evt) {
				evt.preventDefault();
				password.set_password(this.password, this.token).then((res) => {
					this.$router.push({ name: "logout" });
				});
			},
			checkPassword() {
				this.password_length = this.password.length;
				const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

				if (this.password_length > 8) {
					this.contains_eight_characters = true;
				} else {
					this.contains_eight_characters = false;
				}

				this.contains_number = /\d/.test(this.password);
				this.contains_uppercase = /[A-Z]/.test(this.password);
				this.contains_special_character = format.test(this.password);

				if (
					this.contains_eight_characters === true &&
					this.contains_special_character === true &&
					this.contains_uppercase === true &&
					this.contains_number === true
				) {
					this.valid_password = true;
				} else {
					this.valid_password = false;
				}
			},
			getUserSelf: async function () {
				try {
					this.user = await users.getSelf();
					this.name = this.user.prenom;
					this.family = this.user.nom;
					this.id = this.user.identifiant;
					this.email = this.user.email;

					if (!this.user.details) this.user.details = {};

					this.jwt = this.user.jwt || "non défini";

					if (!this.user.env) this.user.env = "";
				} catch (error) {
					console.log(error);
				}
			},
			getDaysArray: function (s, e) {
				for (
					var a = [], d = new Date(s);
					d <= e;
					d.setDate(d.getDate() + 1)
				) {
					a.push(new Date(d));
				}
				return a;
			},
		},
		created: async function () {

			this.store = store;
			
			await this.getUserSelf();

			let response = await users.getSelf(true);

			this.client = response.client;

			if (!this.client.details) this.cient.details = {};

			if (!this.client.details.profile) this.client.details.profile = {};

			if (!this.client.details.env) this.client.details.env = {};

			if (this.user.groups && this.user.groups.indexOf("|") > 0) 
			{
				this.user_groups = this.user.groups.split("|");
				this.group = this.user_groups[0];

				var groups = await client.getClientGroups();

				this.obj_groups = {};
				for (var i = 0; i < groups.length; i++) 
				{
					if (this.user_groups.includes(groups[i].uid))
					{
						this.obj_groups[groups[i].uid] = groups[i];
						this.groups.push({
							value: groups[i].uid,
							text: groups[i].name,
						});
					}
				}

			}

			this.env_list = [""];
			var keys = Object.keys(this.client.details.env);
			for (var i = 0; i < keys.length; i++) {
				this.env_list.push({
					text: this.client.details.env[keys[i]].name,
					value: keys[i],
				});
			}

			if (this.client.details && this.client.details.credits)
			{
				var credits_history = await client.creditHistoryDate();
				var values = [];

				for (var i = 0; i < credits_history.length; i++) 
				{
					values.push({x: new Date(credits_history[i].date), y: -credits_history[i].value});
				}

				this.credits = {
					datasets: [
						{
							fill: false,
							label: "Consommation de crédits",
							data: values,
							backgroundColor: "#0000ff"
						},
					]
				};
			}

			if (this.isAdmin())
			{
				var data = await client.getBandwidth();
				var values = [];

				for (var i = 0; i < data.length; i++) 
				{
					values.push({x: new Date(data[i].date), y: data[i].compteur});
					this.bandwidth_sum += parseFloat(data[i].compteur);
				}

				this.bandwidth = {
					datasets: [
						{
							fill: false,
							label: "Bande passante (mo) - traitements",
							data: values,
							backgroundColor: "#0000ff"
						},
					]
				};

				var data = await client.getEditorBandwidth();
				var values = [];

				for (var i = 0; i < data.length; i++) 
				{
					values.push({x: new Date(data[i].date), y: data[i].compteur});
					this.editor_bandwidth_sum += parseFloat(data[i].compteur);
				}

				this.editor_bandwidth = {
					datasets: [
						{
							fill: false,
							label: "Bande passante (mo) - editeur de scénario",
							data: values,
							backgroundColor: "#0000ff"
						},
					]
				};
			}
		},
	};
</script>

<style scoped>
	ul {
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	li {
		margin-bottom: 8px;
		color: #525f7f;
		position: relative;
	}

	li:before {
		content: "";
		width: 0%;
		height: 2px;
		background: #2ecc71;
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}

	/* Password Input --------- */

	.input_container {
		position: relative;
		padding: 30px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
			0 6px 6px rgba(0, 0, 0, 0.23);
		border-radius: 6px;
		background: #fff;
	}

	input[type="password"] {
		line-height: 1.5;
		display: block;
		color: rgba(136, 152, 170, 1);
		font-weight: 300;
		width: 100%;
		height: calc(2.75rem + 2px);
		padding: 0.625rem 0.75rem;
		border-radius: 0.25rem;
		background-color: #fff;
		transition: border-color 0.4s ease;
		border: 1px solid #cad1d7;
		outline: 0;
	}

	input[type="password"]:focus {
		border-color: rgba(50, 151, 211, 0.45);
	}

	/* Checkmark & Strikethrough --------- */

	.is_valid {
		color: rgba(136, 152, 170, 0.8);
	}
	.is_valid:before {
		width: 100%;
	}

	.checkmark_container {
		border-radius: 50%;
		position: absolute;
		top: -15px;
		right: -15px;
		background: #2ecc71;
		width: 50px;
		height: 50px;
		visibility: hidden;
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.4s ease;
	}

	.show_checkmark {
		visibility: visible;
		opacity: 1;
	}

	.checkmark {
		width: 100%;
		height: 100%;
		fill: none;
		stroke: white;
		stroke-width: 15;
		stroke-linecap: round;
		stroke-dasharray: 180;
		stroke-dashoffset: 180;
	}

	.checked {
		animation: draw 0.5s ease forwards;
	}

	@keyframes draw {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
